import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { StepFormContext } from 'components/StepForm';

import Styled from './styles';

export interface StepLineProps {
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any
  /** @ignore */
  style?: React.CSSProperties,
  /** @ignore If true, this StepLine is part of a parent Step. */
  isSubStep?: boolean;
  /** @ignore */
  $numberOfLines?: number,
}

/** `StepLine`, all other props will be provided to the root component.` */
const StepLine = React.forwardRef<HTMLElement, StepLineProps>((props: StepLineProps, ref) => getContext(({ RTL, theme }) => {
  const {
    theme: themeProp,
    isSubStep,
    ...otherProps
  } = props;
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM);
  const stepFormContext = useContext(StepFormContext);
  const { isHorizontal } = stepFormContext;
  const horizontalLine = <Styled.HorizontalStepLine rtl={RTL} ref={ref} $theme={resolvedTheme} $isSubStep={isSubStep} {...otherProps} />;
  const verticalLine = <Styled.StepLine rtl={RTL} ref={ref} $theme={resolvedTheme} $isSubStep={isSubStep} {...otherProps} />;

  return isHorizontal ? horizontalLine : verticalLine;
}));

StepLine.defaultProps = {
  theme: {},
  style: {},
  isSubStep: false,
  $numberOfLines: 0,
};

StepLine.displayName = 'StepLine';

export default StepLine;